import { render, staticRenderFns } from "./SplitRecordManage.vue?vue&type=template&id=2e480d15&scoped=true"
import script from "./SplitRecordManage.vue?vue&type=script&lang=js"
export * from "./SplitRecordManage.vue?vue&type=script&lang=js"
import style0 from "./SplitRecordManage.vue?vue&type=style&index=0&id=2e480d15&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e480d15",
  null
  
)

export default component.exports